/**
 * The closed set of entity types for the four generic keying tables (notes, attachments,
 * events, external_refs) — core-data-model Q9 / §3.2. 'org' is legal so org-level events
 * (e.g. MCP calls) can key on the org itself (mcp-server-design §2.5).
 */
export const ENTITY_TYPES = [
  'customer',
  'property',
  'contact',
  'job',
  'commercial_job',
  'visit',
  'quote',
  'invoice',
  'payment',
  'agreement',
  'request',
  'template',
  'checklist',
  'location',
  'vendor',
  'purchase_order',
  'equipment',
  'project',
  // 106: a COMPANY asset (van, tool) — distinct from customer-owned 'equipment'.
  'asset',
  // Ops insights Phase 5a: a problem after a visit (CONTEXT.md "Ticket").
  'ticket',
  'org',
] as const;
export type EntityType = (typeof ENTITY_TYPES)[number];

/** Server-assigned display-number counters (org_counters.counter_key). */
export const COUNTER_KEYS = [
  'job',
  'commercial_job',
  'quote',
  'invoice',
  'request',
  'purchase_order',
  'project',
  'ticket',
  'restock',
] as const;
export type CounterKey = (typeof COUNTER_KEYS)[number];

export const formatJobNumber = (n: number): string => `JOB-${n}`;
export const formatProjectNumber = (n: number): string => `PRJ-${n}`;
